export type ListingStatusCD = "ACT" | "PEND" | "TNAFS" | string;

export enum ListingStatusCodes {
	"Pending" = "PEND",
	"Active" = "ACT",
	"Incomplete" = "I",
	"Cancelled" = "CANCL",
	"Sold" = "CLOSD",
	"Comp Sold" = "COMPS",
	"Coming Soon" = "CSN",
	"Deleted" = "D",
	"Expired" = "EXP",
	"Incomplete Deleted" = "ID",
	"Office Approval Active" = "OAA",
	"Office Approval Comp Sold" = "OAS",
	"Office Approval Withheld" = "OAW",
	"Office Approval Coming Soon" = "OACS",
	"Rented" = "RENTD",
	"TNAFS" = "TNAFS",
	"Withheld" = "W",
	"Withheld Deleted" = "WD",
	"Withheld Expired" = "WE",
}

export const INACTIVE_LISTING_STATUSES = [
	ListingStatusCodes.Deleted,
	ListingStatusCodes["Incomplete Deleted"],
	ListingStatusCodes["Withheld Deleted"],
	ListingStatusCodes["Withheld Expired"],
];

export const ADBUILDER_LISTING_STATUSES = [
	ListingStatusCodes.Active,
	ListingStatusCodes.Pending,
	ListingStatusCodes.Sold,
	ListingStatusCodes["Coming Soon"],
	ListingStatusCodes.Rented,
];

export const INACTIVE_LISTING_NAVIGATION_STATUSES = [
	ListingStatusCodes.Deleted,
	ListingStatusCodes["Incomplete Deleted"],
	ListingStatusCodes["Withheld Deleted"],
];

export const SAVE_AND_CONTINUE_STATUSES = [
	ListingStatusCodes.Incomplete,
	ListingStatusCodes.Withheld,
];

export const listingStatusCodeToName = {
	PEND: "Pending",
	ACT: "Active",
	I: "Incomplete",
	CANCL: "Cancelled",
	CLOSD: "Sold",
	COMPS: "Comp Sold",
	CSN: "Coming Soon",
	D: "Delete",
	EXP: "Expired",
	ID: "Incomplete Deleted",
	OAA: "Office Approval Active",
	OAS: "Office Approval Comp Sold",
	OAW: "Office Approval Withheld",
	OACS: "Office Approval Coming Soon",
	RENTD: "Rented",
	TNAFS: "TNAFS",
	W: "Withheld",
	WD: "Withheld Deleted",
	WE: "Withheld Expired",
};
